module.exports = __webpack_public_path__ + "img/loop.3a18fc7b.svg";